import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-userstargrey',
  standalone: true,
  templateUrl: '../../assets/userstargrey.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamUserstargreyIcon {}
